import React, { useEffect, useState, useRef, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { FaPhoneAlt, FaRegEnvelopeOpen, FaRegPaperPlane } from "react-icons/fa";
import { AiOutlinePoweroff, AiOutlineKey } from "react-icons/ai";
import { Badge, Button, Table } from 'react-bootstrap';
import Loader from '../../component/loader';
import ChangeStatusModal from "../../component/changestatusmodal";
import axios from "axios";
import Cookies from "js-cookie";
import { decrpt } from "../../component/encryption";
import ReactToPrint from 'react-to-print';
import ComponentToPrint from './componentToPrint';
import ComponentToPrintLabel from './componentToPrintLabel';

function OrderSingle() {
  const printInvoiceRef = useRef();
  const printLabelRef = useRef();
  const location = useLocation();

  const [loader, setLoader] = useState(false)
  const [show, setShow] = useState(false);
  const [orderData, setOrderData] = useState();
  const [orderDetails, setOrderDetails] = useState();
  const [addresses, setAddresses] = useState([]);
  const [fetchingAddresses, setFetchingAddresses] = useState(false);
  const [selectedPickups, setSelectedPickups] = useState({});
  const [shiprocketShipments, setShiprocketShipments] = useState([]);
  const [loadingShipments, setLoadingShipments] = useState(false);
  const [expandedCouriers, setExpandedCouriers] = useState({});
  const [updatingStatus, setUpdatingStatus] = useState(false);
  console.log(orderData, 'orderData');


  useEffect(() => {
    const fetchAddresses = async () => {
      setFetchingAddresses(true);
      try {

        let token = decrpt(Cookies.get('s_l'));



        const res = await axios.get('/admin/shiprocket/pickup-address/list', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        console.log('the res is', res.data);
        if (res.data?.status && Array.isArray(res.data.data)) {
          setAddresses(res.data.data);
        }
      } catch (err) {
        console.error('Failed to fetch pickup addresses:', err);
      } finally {
        setFetchingAddresses(false);
      }
    };

    fetchAddresses();
  }, []);

  const handleClose = () => {
    setShow(false);
  };
  const statusModal = () => {
    setShow(true);
  };

  let itemid = location.state.item;

  const fetchShiprocketShipments = async (orderId) => {
    if (!orderId) return;
    setLoadingShipments(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      const res = await axios.get(`/admin/shiprocket/shipment-details/${orderId}`, {
        headers: { Authorization: `Bearer ${newToken}` }
      });
      if (res.data?.status && res.data.data) {
        // API returns a single object for by-order lookup
        const payload = res.data.data;
        setShiprocketShipments(Array.isArray(payload) ? payload : [payload]);
      } else {
        setShiprocketShipments([]);
      }
    } catch {
      setShiprocketShipments([]);
    } finally {
      setLoadingShipments(false);
    }
  };

  const orderDetailsFetch = async () => {
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
      const response = await axios.post(`/admin/orders/details`, { order_id: itemid })
      console.log(response, 'order details list');
      const od = response.data.order_data;
      setOrderData(od);
      setOrderDetails(response.data.order_details);
      setLoader(false);
      // Fetch shiprocket details using the internal DB id
      if (od && od.id) {
        fetchShiprocketShipments(od.id);
      } else if (od && od.order_id) {
        fetchShiprocketShipments(od.order_id);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }

  const getStatusLabel = (s) => {
    switch (Number(s)) {
      case 1: return "Placed (New)";
      case 2: return "Confirmed (Accepted)";
      case 3: return "Shipped (Dispatched)";
      case 4: return "Out for Delivery";
      case 5: return "Delivered";
      case 6: return "Cancelled by User";
      case 7: return "Cancelled by Seller";
      case 8: return "Cancelled by Admin";
      default: return "Unknown";
    }
  };

  const handleStatusChange = async (newStatus) => {
    if (!orderData || !orderData.id) return;
    const confirmChange = window.confirm(`Are you sure you want to change order status to "${getStatusLabel(newStatus)}"?`);
    if (!confirmChange) return;

    setUpdatingStatus(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      const res = await axios.post('/admin/orders/status/update', {
        order_id: orderData.id,
        status: Number(newStatus)
      }, {
        headers: { Authorization: `Bearer ${newToken}` }
      });

      if (res.data?.success) {
        setOrderData(prev => ({
          ...prev,
          order_status: Number(newStatus)
        }));
        alert(`Order status updated successfully to "${getStatusLabel(newStatus)}"`);
        orderDetailsFetch();
      } else {
        alert(res.data?.message || 'Failed to update order status');
      }
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || 'Error updating order status');
    } finally {
      setUpdatingStatus(false);
    }
  };

  // let discount = Math.floor(100 * ((orderData && orderData.mrp) - (productDetails && productDetails.price))/(productDetails && productDetails.mrp));

  const handleShiprocket = async (vendorId, vendorItems) => {
    try {
      if (!orderData) {
        alert("Order data is not loaded yet.");
        return;
      }

      console.log("the order data is", orderData)

      // Fallbacks for order properties
      const orderUuid = orderData.order_uuid || `ORDER-${Date.now()}`;
      const orderDate = orderData.order_date || new Date().toISOString().split('T')[0];
      const userName = orderData.user_name || "Customer";

      // Use shipping address if billing address is not set
      const billing = (orderData.billingAddress && orderData.billingAddress.address)
        ? orderData.billingAddress
        : (orderData.shippingAddress || {});

      const billingAddress = billing.address || "No Address Provided";
      const billingCity = billing.city || "Guwahati";
      const billingPin = billing.pin || "781001";
      const billingState = billing.state || "Assam";
      const billingPhone = billing.mobile || "9999999999";

      // Calculate packaging dimensions and weight from vendorItems (product details)
      let totalWeight = 0;
      let maxLength = 0;
      let maxBreadth = 0;
      let maxHeight = 0;

      if (vendorItems && vendorItems.length > 0) {
        vendorItems.forEach(item => {
          const qty = Number(item.quantity || 1);
          totalWeight += Number(item.weight || 0.5) * qty;
          maxLength = Math.max(maxLength, Number(item.length || 10));
          maxBreadth = Math.max(maxBreadth, Number(item.breadth || 10));
          maxHeight = Math.max(maxHeight, Number(item.height || 10));
        });
      } else {
        totalWeight = 0.5;
        maxLength = 10;
        maxBreadth = 10;
        maxHeight = 10;
      }

      // Ensure length, breadth, height, weight are valid
      if (totalWeight <= 0) totalWeight = 0.5;
      if (maxLength <= 0) maxLength = 10;
      if (maxBreadth <= 0) maxBreadth = 10;
      if (maxHeight <= 0) maxHeight = 10;

      let pickupLocationCode = selectedPickups[vendorId];
      if (!pickupLocationCode) {
        if (vendorId && vendorId !== 'unknown') {
          const sellerAddress = addresses.find(addr => String(addr.seller_id) === String(vendorId));
          if (sellerAddress) {
            pickupLocationCode = sellerAddress.pickup_code;
          }
        }
      }
      if (!pickupLocationCode && addresses.length > 0) {
        pickupLocationCode = addresses[0].pickup_code;
      }
      if (!pickupLocationCode) {
        pickupLocationCode = "Primary";
      }

      setLoader(true);

      const mappedItems = vendorItems && vendorItems.length > 0 ? vendorItems.map(p => {
        const item = {
          name: p.product_name,
          sku: `${orderUuid}-${vendorId}`,
          units: p.quantity,
          selling_price: p.price,
          discount: p.mrp ? (p.mrp - p.price) : 0
        };
        if (p.tax) item.tax = p.tax;
        if (p.hsn) item.hsn = p.hsn;
        return item;
      }) : [{
        name: "Product",
        sku: `${orderUuid}-${vendorId}`,
        units: 1,
        selling_price: orderData.total_price,
        discount: 0
      }];

      const vendorSubTotal = vendorItems ? vendorItems.reduce((sum, item) => sum + Number(item.product_price_with_gst || (item.price * item.quantity)), 0) : orderData.total_price;

      const [bFirstName, ...bRest] = userName.split(' ');
      const bLastName = bRest.join(' ') || '';

      const payload = {
        "order_id": `${orderUuid}-${vendorId}`,
        "order_date": orderDate,
        "pickup_location": pickupLocationCode,
        "comment": "Order from Aivimart",
        "billing_customer_name": bFirstName,
        "billing_last_name": bLastName,
        "billing_address": billingAddress,
        "billing_address_2": billing.street || "",
        "billing_city": billingCity,
        "billing_pincode": billingPin,
        "billing_state": billingState,
        "billing_country": billing.country || "India",
        "billing_email": orderData.email || "customer@aivimart.com",
        "billing_phone": billingPhone,
        "shipping_is_billing": true,
        "order_items": mappedItems,
        "payment_method": orderData.payment_type || "COD",
        "shipping_charges": orderData.shipping_charge || 0,
        "giftwrap_charges": orderData.giftwrap_charges || 0,
        "transaction_charges": orderData.transaction_charges || 0,
        "total_discount": orderData.total_discount || 0,
        "sub_total": vendorSubTotal,
        "length": maxLength,
        "breadth": maxBreadth,
        "height": maxHeight,
        "weight": totalWeight
      };

      console.log('Payload Shiprocket :::', payload);

      const token = Cookies.get('s_l');
      const newToken = decrpt(token);

      const response = await axios.post('/admin/shiprocket/create-order', payload, {
        headers: {
          'Authorization': `Bearer ${newToken}`
        }
      });
      console.log('Shiprocket Response:', response.data);
      alert('Shiprocket order created successfully!');
    } catch (error) {
      console.error('Shiprocket Error:', error.response?.data || error.message);
      alert('Failed to create Shiprocket order');
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    orderDetailsFetch(itemid);
  }, []);

  const groupedOrderDetails = useMemo(() => {
    if (!orderDetails) return {};
    return orderDetails.reduce((acc, item) => {
      const sellerId = item.seller_id || 'unknown';
      if (!acc[sellerId]) acc[sellerId] = [];
      acc[sellerId].push(item);
      return acc;
    }, {});
  }, [orderDetails]);

  useEffect(() => {
    if (addresses.length > 0 && Object.keys(groupedOrderDetails).length > 0) {
      const initialPickups = {};
      Object.keys(groupedOrderDetails).forEach(vendorId => {
        const sellerAddress = addresses.find(addr => 
          vendorId === 'unknown' ? !addr.seller_id : String(addr.seller_id) === String(vendorId)
        );
        if (sellerAddress) {
          initialPickups[vendorId] = sellerAddress.pickup_code;
        } else if (addresses.length > 0) {
          initialPickups[vendorId] = addresses[0].pickup_code;
        } else {
          initialPickups[vendorId] = "";
        }
      });
      setSelectedPickups(initialPickups);
    }
  }, [addresses, groupedOrderDetails]);

  const primaryPickupAddress = useMemo(() => {
    if (!addresses || addresses.length === 0) return null;
    const vendorIds = Object.keys(groupedOrderDetails);
    const matched = addresses.find(addr => 
      vendorIds.some(vId => vId !== 'unknown' && String(addr.seller_id) === String(vId))
    );
    return matched || addresses[0];
  }, [addresses, groupedOrderDetails]);

  return (
    <div className="main-content" style={{ padding: '20px 24px', backgroundColor: '#f4f6f9', minHeight: 'calc(100vh - 55px)', margin: '0 -10px -10px -10px' }}>
      {loader ? (
        <Loader />
      ) : (
        <div>
          {/* Top Header Card */}
          <div className="card border-0 shadow-sm rounded-3 mb-3 p-3 bg-white">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div>
                <div className="d-flex align-items-center gap-2">
                  <h4 className="mb-0 fw-bold text-dark">{orderData?.order_uuid || 'Order Details'}</h4>
                  {orderData && (
                    Number(orderData.order_status) === 1 ? <Badge bg="primary">New</Badge> :
                    Number(orderData.order_status) === 2 ? <Badge bg="success">Accepted</Badge> :
                    Number(orderData.order_status) === 3 ? <Badge bg="warning" className="text-dark">Dispatch</Badge> :
                    Number(orderData.order_status) === 4 ? <Badge bg="secondary">Out for Delivery</Badge> :
                    Number(orderData.order_status) === 5 ? <Badge bg="success">Delivered</Badge> :
                    <Badge bg="danger">Cancelled</Badge>
                  )}
                </div>
                <div className="d-flex align-items-center gap-3 text-muted mt-1" style={{ fontSize: '13px' }}>
                  <span><strong>Order Date:</strong> {orderData?.order_date || '—'}</span>
                  <span>•</span>
                  <span><strong>Delivered Date:</strong> {orderData?.delivered_date || '—'}</span>
                  {orderData?.user_name && (
                    <>
                      <span>•</span>
                      <span><strong>Customer:</strong> {orderData.user_name}</span>
                    </>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center gap-2 hidestuff">
                <ReactToPrint
                  trigger={() => (
                    <button className="btn btn-warning btn-sm text-dark fw-bold px-3 shadow-sm" type="button">
                      Print Receipt
                    </button>
                  )}
                  content={() => printInvoiceRef.current}
                  pageStyle="@page { size: A4 portrait; margin: 8mm; } @media print { html, body { margin: 0 !important; padding: 0 !important; } }"
                />
                <ReactToPrint
                  trigger={() => (
                    <button className="btn btn-dark btn-sm fw-bold px-3 shadow-sm" type="button">
                      Print Label
                    </button>
                  )}
                  content={() => printLabelRef.current}
                  pageStyle="@page { size: auto; margin: 0; } @media print { html, body { height: 100% !important; margin: 0 !important; padding: 3mm !important; overflow: hidden !important; } }"
                />
              </div>
            </div>

            {/* Quick KPI Stats Row */}
            <div className="row g-2 mt-2 pt-3 border-top">
              <div className="col-sm-6 col-md-3">
                <div className="p-2 rounded bg-light border">
                  <div className="text-muted fw-bold" style={{ fontSize: '11px' }}>CUSTOMER TOTAL</div>
                  <div className="fs-5 fw-bold text-dark">₹ {Number(orderData?.overall_price || 0).toFixed(2)}</div>
                </div>
              </div>
              <div className="col-sm-6 col-md-3">
                <div className="p-2 rounded bg-light border">
                  <div className="text-muted fw-bold" style={{ fontSize: '11px' }}>NET ORDER AMOUNT</div>
                  <div className="fs-5 fw-bold text-success">
                    ₹ {Number(orderData?.order_amount || (Number(orderData?.overall_price || 0) - Number(orderData?.gateway_fee || 0) - Number(orderData?.gateway_gst || 0) - Number(orderData?.shipping_charge || 0))).toFixed(2)}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-3">
                <div className="p-2 rounded bg-light border">
                  <div className="text-muted fw-bold" style={{ fontSize: '11px' }}>PAYMENT</div>
                  <div className="fs-6 fw-bold mt-1">
                    <Badge bg={orderData?.payment_type === 'Online' ? 'primary' : 'secondary'} className="me-1">
                      {orderData?.payment_type === 'COD' ? 'Cash on Delivery' : 'Online'}
                    </Badge>
                    <Badge bg={orderData?.payment_status == 2 ? 'success' : 'warning'} text={orderData?.payment_status == 2 ? 'light' : 'dark'}>
                      {orderData?.payment_status == 1 ? 'Pending' : (orderData?.payment_status == 2 ? 'Paid' : 'Failed')}
                    </Badge>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-3">
                <div className="p-2 rounded bg-light border">
                  <div className="text-muted fw-bold" style={{ fontSize: '11px' }}>SHIPROCKET FREIGHT</div>
                  <div className="fs-5 fw-bold" style={{ color: '#f77f00' }}>
                    {shiprocketShipments[0]?.assigned_freight != null
                      ? '₹ ' + Number(shiprocketShipments[0].assigned_freight).toFixed(2)
                      : '—'}
                  </div>
                  {shiprocketShipments[0]?.assigned_courier_name && (
                    <small className="text-muted d-block text-truncate" style={{ fontSize: '10px' }}>
                      {shiprocketShipments[0].assigned_courier_name}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* 2-Column Main Section */}
          <div className="row g-3">
            {/* LEFT COLUMN: Lifecycle, Vendor Items, Courier Tracking (col-lg-8) */}
            <div className="col-lg-8">
              {/* Order Delivery Stage Card */}
              <div className="card border-0 shadow-sm rounded-3 mb-3 p-3 bg-white">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <div className="text-muted text-uppercase fw-bold" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                      ORDER DELIVERY STAGE
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-1">
                      <span className="fw-bold" style={{ fontSize: '14px' }}>Current:</span>
                      <span className="badge bg-dark fs-6">{getStatusLabel(orderData?.order_status)}</span>
                    </div>
                  </div>

                  {/* Dropdown to change stage */}
                  <div className="d-flex align-items-center gap-2 hidestuff">
                    <label className="fw-bold mb-0 text-dark" style={{ whiteSpace: 'nowrap', fontSize: '13px' }}>
                      Update Stage:
                    </label>
                    <select
                      className="form-select form-select-sm border-primary fw-semibold"
                      style={{ width: '210px' }}
                      value={orderData?.order_status || 1}
                      disabled={updatingStatus}
                      onChange={(e) => handleStatusChange(e.target.value)}
                    >
                      <option value="1">1. Placed (New)</option>
                      <option value="2">2. Confirmed (Accepted)</option>
                      <option value="3">3. Shipped (Dispatched)</option>
                      <option value="4">4. Out for Delivery</option>
                      <option value="5">5. Delivered</option>
                      <option disabled>──────────</option>
                      <option value="8">8. Cancelled (By Admin)</option>
                    </select>
                    {updatingStatus && <div className="spinner-border spinner-border-sm text-primary" role="status"></div>}
                  </div>
                </div>

                {/* Visual Progress Stepper */}
                {orderData && ![6, 7, 8].includes(Number(orderData.order_status)) && (
                  <div className="d-flex align-items-center justify-content-between mt-3 pt-3 border-top px-2">
                    {[
                      { id: 1, label: "Placed" },
                      { id: 2, label: "Confirmed" },
                      { id: 3, label: "Shipped" },
                      { id: 4, label: "Out for Delivery" },
                      { id: 5, label: "Delivered" },
                    ].map((step, idx) => {
                      const current = Number(orderData.order_status) || 1;
                      const isDone = current >= step.id;
                      const isCurrent = current === step.id;
                      return (
                        <React.Fragment key={step.id}>
                          <div
                            onClick={() => !updatingStatus && current !== step.id && handleStatusChange(step.id)}
                            style={{
                              cursor: updatingStatus ? 'not-allowed' : 'pointer',
                              textAlign: 'center',
                              flex: 1
                            }}
                            title={'Click to set stage to ' + step.label}
                          >
                            <div
                              style={{
                                width: '34px',
                                height: '34px',
                                borderRadius: '50%',
                                backgroundColor: isDone ? '#10B981' : '#E5E7EB',
                                color: isDone ? '#FFFFFF' : '#6B7280',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                fontSize: '13px',
                                border: isCurrent ? '3px solid #059669' : 'none',
                                boxShadow: isCurrent ? '0 0 0 3px rgba(16, 185, 129, 0.25)' : 'none',
                                margin: '0 auto'
                              }}
                            >
                              {isDone ? '✓' : step.id}
                            </div>
                            <div style={{
                              fontSize: '11px',
                              fontWeight: isCurrent ? 'bold' : '500',
                              color: isDone ? '#065F46' : '#6B7280',
                              marginTop: '4px'
                            }}>
                              {step.label}
                            </div>
                          </div>
                          {idx < 4 && (
                            <div
                              style={{
                                height: '3px',
                                flex: 1,
                                backgroundColor: current > step.id ? '#10B981' : '#E5E7EB',
                                marginBottom: '18px'
                              }}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Vendor Products Section */}
              {Object.keys(groupedOrderDetails).map((vendorId) => {
                const vendorItems = groupedOrderDetails[vendorId] || [];
                return (
                  <div className="card border-0 shadow-sm rounded-3 mb-3 p-3 bg-white" key={vendorId}>
                    <div className="d-flex flex-wrap align-items-center justify-content-between pb-3 mb-3 border-bottom gap-2">
                      <h6 className="mb-0 fw-bold text-dark">
                        Vendor: <span className="text-primary">{vendorId === 'unknown' ? 'Admin / In-House' : ('Seller #' + vendorId)}</span>
                      </h6>
                      <div className="d-flex align-items-center gap-2 hidestuff">
                        <select
                          className="form-select form-select-sm"
                          style={{ width: 'auto', minWidth: '160px' }}
                          value={selectedPickups[vendorId] || ''}
                          onChange={(e) => setSelectedPickups(prev => ({ ...prev, [vendorId]: e.target.value }))}
                        >
                          <option value="">Pickup Address</option>
                          {(() => {
                            const matchingAddresses = addresses.filter(addr => 
                              vendorId === 'unknown' ? !addr.seller_id : String(addr.seller_id) === String(vendorId)
                            );
                            const listToRender = matchingAddresses.length > 0 ? matchingAddresses : addresses;
                            return listToRender.map((addr, idx) => (
                              <option key={idx} value={addr.pickup_code}>
                                {addr.pickup_code}{addr.city ? ` (${addr.city})` : ''}
                              </option>
                            ));
                          })()}
                        </select>
                        <button className="btn btn-info btn-sm text-white fw-semibold" type="button" onClick={() => handleShiprocket(vendorId, vendorItems)}>
                          Shiprocket
                        </button>
                      </div>
                    </div>

                    <Table responsive hover className="mb-0 align-middle">
                      <thead className="table-light text-secondary" style={{ fontSize: '12px', textTransform: 'uppercase' }}>
                        <tr>
                          <th>#</th>
                          <th>Product Image</th>
                          <th>Product Name</th>
                          <th className="text-center">Brand</th>
                          <th className="text-center">Qty</th>
                          <th className="text-end">MRP</th>
                          <th className="text-end">Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vendorItems.map((item, index) => (
                          <tr key={index}>
                            <td className="text-muted">{index + 1}</td>
                            <td>
                              <img
                                src={item.product_image}
                                alt=""
                                style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #e5e7eb' }}
                              />
                            </td>
                            <td>
                              <div className="fw-bold text-dark" style={{ fontSize: '14px' }}>{item.product_name}</div>
                              <small className="text-muted">
                                {[item.category, item.sub_category].filter(Boolean).join(' › ')}
                              </small>
                            </td>
                            <td className="text-center text-muted">{item.brand || '—'}</td>
                            <td className="text-center fw-bold">{item.quantity}</td>
                            <td className="text-end text-muted">₹{Number(item.mrp || 0).toFixed(2)}</td>
                            <td className="text-end fw-bold text-dark">₹{Number(item.price || 0).toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                    {/* Seller Settlement Breakdown Box */}
                    <div className="mt-3 pt-3 border-top bg-light p-3 rounded">
                      <h6 className="fw-bold text-dark mb-2" style={{ fontSize: '13px' }}>Seller Payment Calculation & Breakdown</h6>
                      <Table bordered size="sm" className="mb-2 bg-white" style={{ fontSize: '12px' }}>
                        <thead className="table-light">
                          <tr>
                            <th>Product Name</th>
                            <th className="text-end">Base Price</th>
                            <th className="text-end">GST</th>
                            <th className="text-end">Price + GST</th>
                            <th className="text-end">Category Comm.</th>
                            <th className="text-end">Total</th>
                            <th className="text-end">Comm. GST (18%)</th>
                            <th className="text-end fw-bold text-success">Seller Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vendorItems.map((item, idx) => {
                            const pPrice = Number(item.product_price || (item.price * item.quantity) || 0);
                            const pGstRate = Number(item.product_gst_rate || 18);
                            const pGstAmount = Number(item.product_gst_amount || (pPrice * (pGstRate / 100)) || 0);
                            const pWithGst = Number(item.product_price_with_gst || (pPrice + pGstAmount) || 0);
                            const commRate = Number(item.commission_rate || 0);
                            const commAmount = Number(item.commission_amount || (pPrice * (commRate / 100)) || 0);
                            const totalWithComm = Number(item.total_with_commission || (pWithGst - commAmount) || 0);
                            const commGst = Number(item.commission_gst || (commAmount * 0.18) || 0);
                            const sellerAmt = Number(item.seller_amount || (totalWithComm - commGst) || 0);

                            return (
                              <tr key={idx}>
                                <td><strong>{item.product_name}</strong></td>
                                <td className="text-end">₹ {pPrice.toFixed(2)}</td>
                                <td className="text-end">₹ {pGstAmount.toFixed(2)} <small className="text-muted">({pGstRate}%)</small></td>
                                <td className="text-end">₹ {pWithGst.toFixed(2)}</td>
                                <td className="text-end">₹ {commAmount.toFixed(2)} <small className="text-muted">({commRate}%)</small></td>
                                <td className="text-end">₹ {totalWithComm.toFixed(2)}</td>
                                <td className="text-end text-danger">- ₹ {commGst.toFixed(2)}</td>
                                <td className="text-end fw-bold text-success">₹ {sellerAmt.toFixed(2)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>

                      <div className="d-flex justify-content-end">
                        <div className="card bg-white border p-2" style={{ minWidth: '320px', fontSize: '13px' }}>
                          <div className="d-flex justify-content-between mb-1">
                            <span className="text-muted">Total Price + GST:</span>
                            <span className="fw-medium">₹ {vendorItems.reduce((s, i) => s + Number(i.product_price_with_gst || (i.price * i.quantity * 1.18) || 0), 0).toFixed(2)}</span>
                          </div>
                          <div className="d-flex justify-content-between mb-1">
                            <span className="text-muted">Category Commission:</span>
                            <span className="fw-medium">₹ {vendorItems.reduce((s, i) => s + Number(i.commission_amount || 0), 0).toFixed(2)}</span>
                          </div>
                          <div className="d-flex justify-content-between mb-1 text-danger">
                            <span>Less Commission GST (18%):</span>
                            <span>- ₹ {vendorItems.reduce((s, i) => s + Number(i.commission_gst || 0), 0).toFixed(2)}</span>
                          </div>
                          <div className="d-flex justify-content-between border-top pt-2 mt-1">
                            <span className="fw-bold text-dark">Net Seller Amount:</span>
                            <span className="fw-bold text-success fs-6">
                              ₹ {vendorItems.reduce((s, i) => s + Number(i.seller_amount || (i.price * i.quantity * 1.18) || 0), 0).toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* Shiprocket Shipment Details Card */}
              <div className="card border-0 shadow-sm rounded-3 mb-3 p-3 bg-white" style={{ borderLeft: '4px solid #f77f00' }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h6 className="fw-bold mb-0" style={{ color: '#f77f00' }}>🚚 Shiprocket Shipment Details</h6>
                  <button
                    className="btn btn-sm btn-outline-warning hidestuff"
                    onClick={() => {
                      const id = orderData?.id || orderData?.order_id;
                      if (id) fetchShiprocketShipments(id);
                    }}
                    disabled={loadingShipments}
                  >
                    {loadingShipments ? 'Refreshing…' : '↻ Refresh'}
                  </button>
                </div>

                {loadingShipments ? (
                  <p className="text-muted text-center py-3 mb-0">Loading shipment data…</p>
                ) : shiprocketShipments.length === 0 ? (
                  <div className="text-center py-3">
                    <p className="text-muted mb-1">No Shiprocket shipment found for this order.</p>
                    <small className="text-muted">Use the "Shiprocket" button above to create one.</small>
                  </div>
                ) : (
                  shiprocketShipments.map((shipment, idx) => (
                    <div key={shipment.id || idx} className="border rounded p-3 mb-3" style={{ background: '#fffaf3' }}>
                      <div className="d-flex flex-wrap gap-3 mb-3 align-items-start">
                        <div style={srStyles.chip}>
                          <span style={srStyles.chipLabel}>Shiprocket Order ID</span>
                          <span style={srStyles.chipValue}>#{shipment.shiprocket_order_id || '—'}</span>
                        </div>
                        <div style={srStyles.chip}>
                          <span style={srStyles.chipLabel}>Shipment ID</span>
                          <span style={srStyles.chipValue}>#{shipment.shipment_id || '—'}</span>
                        </div>
                        <div style={srStyles.chip}>
                          <span style={srStyles.chipLabel}>Order UUID</span>
                          <span style={srStyles.chipValue}>{shipment.frontend_order_uuid || shipment.order_uuid || '—'}</span>
                        </div>
                        <div style={srStyles.chip}>
                          <span style={srStyles.chipLabel}>Created At</span>
                          <span style={srStyles.chipValue}>{shipment.created_at ? new Date(shipment.created_at).toLocaleString('en-IN') : '—'}</span>
                        </div>
                      </div>

                      {/* Assigned Courier */}
                      <div className="p-3 rounded mb-3" style={{ background: '#fff3e0', border: '1px solid #ffe0b2' }}>
                        <h6 className="fw-bold mb-2" style={{ color: '#e65100', fontSize: '13px' }}>✅ Assigned Courier</h6>
                        <div className="d-flex flex-wrap gap-4">
                          <div>
                            <div style={srStyles.detailLabel}>Courier Name</div>
                            <div style={srStyles.detailValue}>{shipment.assigned_courier_name || <span className="text-muted">Not assigned</span>}</div>
                          </div>
                          <div>
                            <div style={srStyles.detailLabel}>Courier ID</div>
                            <div style={srStyles.detailValue}>{shipment.assigned_courier_id ?? <span className="text-muted">—</span>}</div>
                          </div>
                          <div>
                            <div style={srStyles.detailLabel}>AWB Code</div>
                            <div style={{ ...srStyles.detailValue, fontFamily: 'monospace', fontSize: '15px', color: '#1a6b3c', fontWeight: '700' }}>
                              {shipment.assigned_awb_code || 'Not generated'}
                            </div>
                          </div>
                          <div>
                            <div style={srStyles.detailLabel}>Freight Charged</div>
                            <div style={{ ...srStyles.detailValue, color: '#c62828', fontWeight: '700', fontSize: '15px' }}>
                              {shipment.assigned_freight != null ? '₹ ' + Number(shipment.assigned_freight).toFixed(2) : '—'}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* All Available Couriers */}
                      {Array.isArray(shipment.all_couriers) && shipment.all_couriers.length > 0 && (
                        <div>
                          <button
                            className="btn btn-sm btn-link p-0 mb-2"
                            style={{ color: '#f77f00', fontWeight: '600', textDecoration: 'none', fontSize: '13px' }}
                            onClick={() => setExpandedCouriers(prev => ({ ...prev, [shipment.id || idx]: !prev[shipment.id || idx] }))}
                          >
                            {expandedCouriers[shipment.id || idx] ? '▲ Hide' : '▼ Show'} all {shipment.all_couriers.length} available couriers
                          </button>
                          {expandedCouriers[shipment.id || idx] && (
                            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                              <Table size="sm" bordered responsive className="mb-0 bg-white" style={{ fontSize: '12px' }}>
                                <thead className="table-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Courier</th>
                                    <th>Mode</th>
                                    <th className="text-end">Freight (₹)</th>
                                    <th className="text-end">EDD</th>
                                    <th>COD</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {shipment.all_couriers.map((courier, ci) => (
                                    <tr
                                      key={ci}
                                      style={courier.courier_company_id === shipment.assigned_courier_id ? { background: '#e8f5e9', fontWeight: '600' } : {}}
                                    >
                                      <td>{ci + 1}</td>
                                      <td>
                                        {courier.courier_name}
                                        {courier.courier_company_id === shipment.assigned_courier_id && (
                                          <span className="badge bg-success ms-1" style={{ fontSize: '10px' }}>Selected</span>
                                        )}
                                      </td>
                                      <td>{courier.mode || '—'}</td>
                                      <td className="text-end fw-bold">₹ {Number(courier.freight_charge || 0).toFixed(2)}</td>
                                      <td className="text-end">{courier.etd || courier.estimated_delivery_days || '—'}</td>
                                      <td>{courier.cod ? <span className="text-success fw-bold">Yes</span> : <span className="text-danger">No</span>}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* RIGHT COLUMN: Customer Addresses + Order Price Breakdown (col-lg-4) */}
            <div className="col-lg-4">
              {/* Customer & Addresses Card */}
              <div className="card border-0 shadow-sm rounded-3 mb-3 p-3 bg-white">
                <h6 className="fw-bold text-dark border-bottom pb-2 mb-3">Customer Information</h6>

                <div className="mb-3">
                  <label className="text-muted mb-0 fw-semibold" style={{ fontSize: '11px', textTransform: 'uppercase' }}>
                    Shipping Address
                  </label>
                  {orderData?.shippingAddress ? (
                    <div className="mt-1" style={{ fontSize: '13px' }}>
                      <div className="fw-bold text-dark">{orderData.shippingAddress.user_name || orderData.user_name}</div>
                      <p className="mb-1 text-muted">
                        {[
                          orderData.shippingAddress.address,
                          orderData.shippingAddress.street,
                          orderData.shippingAddress.land_mark,
                          orderData.shippingAddress.city,
                          orderData.shippingAddress.state
                        ].filter(Boolean).join(', ')}
                        {orderData.shippingAddress.pin ? ' - ' + orderData.shippingAddress.pin : ''}
                      </p>
                      <div className="d-flex align-items-center gap-1 text-dark">
                        <FaPhoneAlt size={11} className="text-muted" /> {orderData.shippingAddress.mobile}
                      </div>
                    </div>
                  ) : (
                    <p className="text-muted fst-italic mb-0" style={{ fontSize: '13px' }}>No shipping address</p>
                  )}
                </div>

                <hr className="my-2" />

                <div>
                  <label className="text-muted mb-0 fw-semibold" style={{ fontSize: '11px', textTransform: 'uppercase' }}>
                    Billing Address
                  </label>
                  {orderData?.billingAddress ? (
                    <div className="mt-1" style={{ fontSize: '13px' }}>
                      <div className="fw-bold text-dark">{orderData.billingAddress.user_name || orderData.user_name}</div>
                      <p className="mb-1 text-muted">
                        {[
                          orderData.billingAddress.address,
                          orderData.billingAddress.street,
                          orderData.billingAddress.land_mark,
                          orderData.billingAddress.city,
                          orderData.billingAddress.state
                        ].filter(Boolean).join(', ')}
                        {orderData.billingAddress.pin ? ' - ' + orderData.billingAddress.pin : ''}
                      </p>
                      <div className="d-flex align-items-center gap-1 text-dark">
                        <FaPhoneAlt size={11} className="text-muted" /> {orderData.billingAddress.mobile}
                      </div>
                    </div>
                  ) : (
                    <p className="text-muted fst-italic mb-0" style={{ fontSize: '13px' }}>Same as shipping</p>
                  )}
                </div>
              </div>

              {/* Order Price Breakdown Card */}
              <div className="card border-0 shadow-sm rounded-3 mb-3 p-3 bg-white">
                <h6 className="fw-bold text-dark border-bottom pb-2 mb-3">Order Price Breakdown</h6>
                {(() => {
                  const netOrderAmount = orderData ? (orderData.order_amount ? Number(orderData.order_amount) : (Number(orderData.overall_price || 0) - Number(orderData.gateway_fee || 0) - Number(orderData.gateway_gst || 0) - Number(orderData.shipping_charge || 0))) : 0;
                  const totalSellerAmount = orderDetails ? orderDetails.reduce((s, i) => s + Number(i.seller_amount || 0), 0) : 0;
                  const totalProfitEarned = netOrderAmount - totalSellerAmount;

                  const latestShipment = shiprocketShipments[0] || null;
                  const actualFreight = latestShipment?.assigned_freight != null ? Number(latestShipment.assigned_freight) : null;
                  const shippingCollected = Number(orderData?.shipping_charge || 0);

                  const isCod = orderData?.payment_type === 'COD';
                  const assignedCourier = Array.isArray(latestShipment?.all_couriers)
                    ? latestShipment.all_couriers.find(c => c.courier_company_id === latestShipment.assigned_courier_id)
                    : null;
                  const codBase = (isCod && assignedCourier?.cod_charges != null)
                    ? Number(assignedCourier.cod_charges) : null;
                  const codGst = codBase != null ? +(codBase * 0.18).toFixed(2) : null;
                  const totalCodCost = codBase != null ? +(codBase + codGst).toFixed(2) : null;

                  const shippingMargin = actualFreight != null
                    ? shippingCollected - actualFreight - (totalCodCost ?? 0)
                    : null;
                  const actualNetProfit = actualFreight != null ? totalProfitEarned + shippingMargin : totalProfitEarned;

                  return (
                    <Table borderless size="sm" className="mb-0" style={{ fontSize: '13px' }}>
                      <tbody>
                        <tr>
                          <td className="text-muted py-1">Items Subtotal</td>
                          <td className="text-end fw-semibold py-1">₹ {orderData && Number(orderData.total_price || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td className="text-muted py-1">Shipping Collected</td>
                          <td className="text-end fw-semibold py-1">₹ {shippingCollected.toFixed(2)}</td>
                        </tr>
                        <tr className="border-bottom">
                          <td className="fw-bold text-dark pt-2 pb-2">Customer Total</td>
                          <td className="text-end fw-bold text-dark pt-2 pb-2 fs-6">₹ {orderData && Number(orderData.overall_price || 0).toFixed(2)}</td>
                        </tr>

                        <tr>
                          <td className="text-danger py-1">Platform / Gateway Fee (2%)</td>
                          <td className="text-end text-danger py-1">− ₹ {orderData && Number(orderData.gateway_fee || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td className="text-danger py-1">18% GST on Fee</td>
                          <td className="text-end text-danger py-1">− ₹ {orderData && Number(orderData.gateway_gst || 0).toFixed(2)}</td>
                        </tr>
                        <tr className="border-bottom">
                          <td className="text-danger py-1 pb-2">Less: Shipping Collected</td>
                          <td className="text-end text-danger py-1 pb-2">− ₹ {shippingCollected.toFixed(2)}</td>
                        </tr>

                        <tr className="border-bottom">
                          <td className="fw-bold text-success py-2">Net Item Revenue</td>
                          <td className="text-end fw-bold text-success py-2 fs-6">₹ {netOrderAmount.toFixed(2)}</td>
                        </tr>

                        <tr className="border-bottom">
                          <td className="text-danger py-1 pb-2">Less: Net Seller Payable</td>
                          <td className="text-end text-danger py-1 pb-2">− ₹ {totalSellerAmount.toFixed(2)}</td>
                        </tr>
                        <tr className="border-bottom">
                          <td className="fw-bold text-primary py-2">Platform Profit on Items</td>
                          <td className="text-end fw-bold text-primary py-2 fs-6">₹ {totalProfitEarned.toFixed(2)}</td>
                        </tr>

                        {/* Shipping Reconciliation */}
                        <tr>
                          <td colSpan="2" className="pt-3 pb-1">
                            <span className="fw-bold text-dark" style={{ fontSize: '12px' }}>📦 Shipping & COD Reconciliation</span>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-muted ps-2 py-1">Shipping Collected</td>
                          <td className="text-end py-1">+ ₹ {shippingCollected.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td className="text-muted ps-2 py-1">
                            Actual Shiprocket Freight
                            {latestShipment?.assigned_courier_name && (
                              <small className="text-info ms-1">({latestShipment.assigned_courier_name})</small>
                            )}
                          </td>
                          <td className="text-end py-1">
                            {actualFreight != null
                              ? <span className="text-danger">− ₹ {actualFreight.toFixed(2)}</span>
                              : <span className="text-muted fst-italic">Not booked yet</span>}
                          </td>
                        </tr>

                        {isCod && (
                          <>
                            <tr>
                              <td className="text-muted ps-2 py-1">COD Charge (base)</td>
                              <td className="text-end py-1">
                                {codBase != null ? <span className="text-danger">− ₹ {codBase.toFixed(2)}</span> : '—'}
                              </td>
                            </tr>
                            <tr>
                              <td className="text-muted ps-2 py-1">18% GST on COD</td>
                              <td className="text-end py-1">
                                {codGst != null ? <span className="text-danger">− ₹ {codGst.toFixed(2)}</span> : '—'}
                              </td>
                            </tr>
                          </>
                        )}

                        <tr className="border-bottom">
                          <td className="ps-2 py-1 pb-2">Net Shipping Margin</td>
                          <td className="text-end py-1 pb-2">
                            {shippingMargin != null ? (
                              <span className={shippingMargin >= 0 ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                                {shippingMargin >= 0 ? '+' : '−'} ₹ {Math.abs(shippingMargin).toFixed(2)}
                              </span>
                            ) : '—'}
                          </td>
                        </tr>

                        {/* Actual Net Profit */}
                        <tr>
                          <td className="fw-bold pt-3 fs-6 text-dark">🏦 Actual Net Profit</td>
                          <td
                            className="text-end fw-bold pt-3 fs-5"
                            style={{
                              color: actualNetProfit >= 0 ? '#1a6b3c' : '#c62828',
                            }}
                          >
                            ₹ {actualNetProfit.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  );
                })()}
              </div>
            </div>
          </div>

          {/* Dedicated Tax Invoice / Receipt Component for Printing */}
          <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
            <ComponentToPrint
              ref={printInvoiceRef}
              orderData={orderData}
              orderDetails={orderDetails}
            />
          </div>

          {/* Dedicated Shipping Label Component for Printing */}
          <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
            <ComponentToPrintLabel
              ref={printLabelRef}
              orderData={orderData}
              orderDetails={orderDetails}
              shipment={shiprocketShipments?.[0]}
              pickupAddress={primaryPickupAddress}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderSingle;

const styles = {
  header: { textTransform: 'uppercase', color: '#149348', marginBottom: 0 },
  box: { background: '#e1e1e1', borderRadius: 10, paddingLeft: 10, paddingRight: 10, padding: 10, flex: 1, boxShadow: '0 0 5px 0 #868686', border: '2px dotted #fff' },
  boxHeading: { color: '#333', fontWeight: '900', fontSize: 15, marginBottom: 0 },
  boxNumber: { color: 'green', fontWeight: '900', fontSize: 25, marginBottom: 0 },
};

const srStyles = {
  chip: {
    background: '#fff8ee',
    border: '1px solid #f7c784',
    borderRadius: '8px',
    padding: '6px 12px',
    minWidth: '120px',
  },
  chipLabel: {
    display: 'block',
    fontSize: '10px',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
    color: '#888',
    marginBottom: '2px',
  },
  chipValue: {
    display: 'block',
    fontWeight: '700',
    fontSize: '13px',
    color: '#333',
  },
  detailLabel: {
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#999',
    marginBottom: '3px',
  },
  detailValue: {
    fontWeight: '600',
    fontSize: '14px',
    color: '#222',
  },
};
